module.exports = __webpack_public_path__ + "img/makerspace.9dfe4b61.png";